import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorBoxModule } from '@shared/component/error-box/error-box.module';
import { LanguageSelectorModule } from '@shared/component/language-selector/language-selector.module';
import { FullUrlPipe } from '@shared/pipes/full-url.pipe';
import { SfInputModule } from '@shared/sf-form-controls/sf-input/sf-input.module';
import { SharedModule } from '@shared/shared.module';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { AuthTopBarComponent } from './auth-top-bar/auth-top-bar.component';
import { AuthenticationComponent } from './authentication.component';
import { DemoComponent } from './demo/demo.component';
import { LoginComponent } from './login/login.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

@NgModule({
	declarations: [
		AuthenticationComponent,
		LoginComponent,
		NewPasswordComponent,
		ResetPasswordComponent,
		SignUpComponent,
		VerifyEmailComponent,
		ActivateAccountComponent,
		AuthTopBarComponent,
		DemoComponent,
	],
	imports: [
		CommonModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		RouterModule,
		SfInputModule,
		TranslateModule,
		MatButtonModule,
		MatCheckboxModule,
		MatIconModule,
		SharedModule,
		MatRadioModule,
		MatAutocompleteModule,
		MatInputModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		FullUrlPipe,
		LanguageSelectorModule,
		ErrorBoxModule,
	],
	exports: [],
})
export class AuthenticationModule {}
